import { render } from "./ContactAuraPanel.vue?vue&type=template&id=0039ed94&ts=true"
import script from "./ContactAuraPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactAuraPanel.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/contact/components/ContactAuraPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0039ed94"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0039ed94', __exports__)) {
    api.reload('0039ed94', __exports__)
  }
  
  module.hot.accept("./ContactAuraPanel.vue?vue&type=template&id=0039ed94&ts=true", () => {
    api.rerender('0039ed94', render)
  })

}


export default __exports__